import { Injectable } from '@angular/core';

import { AbstractAsyncTaskReport } from './abstract-async-task.report';
import { ITask } from './async-task-constants';

@Injectable({
  providedIn: 'root'
})
export class LriImportReport extends AbstractAsyncTaskReport {

  public generate(task: ITask): string {
    if (task.status === 'success') {
      return `<div>Import des lignes de demandes logistiques réussi.</div>`;

    } else {
      let htmlDetail = `<div>Échec de l'import des lignes de demandes logistiques.<br></div>`;
      htmlDetail += this.formatOnlyStructureAndContentImportError(task.detail);
      return htmlDetail;
    }
  }
}
